import { Component, ChangeDetectionStrategy, inject, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { NoResultsComponent } from 'libs/shared/ui-common/src/lib/components/no-results/no-results.component';
import { InViewportDirective } from 'libs/shared/util-common/src/lib/directives/in-viewport.directive';
import { AttachmentCardComponent, SpinnerComponent } from 'shared/ui-common';
import { IsMobileService } from 'shared/util-common';

import { AttachmentSearchResult } from '../attachment-search.model';

@Component({
  selector: 'tt-attachment-search-result-list',
  standalone: true,
  imports: [TranslocoModule, SpinnerComponent, InViewportDirective, NoResultsComponent, AttachmentCardComponent],
  templateUrl: './attachment-search-result-list.component.html',
  styleUrls: ['./attachment-search-result-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentSearchResultListComponent {
  protected isMobileService = inject(IsMobileService);

  public searchResults = input<AttachmentSearchResult[]>([]);
  public loading = input<boolean>(false);
  public loadingMore = input<boolean>(false);
  public error = input<string | null>(null);
  public searchTerm = input<string | null>(null);
  public hasMoreResults = input<boolean>(false);

  public loadNextPage = output<void>();
  public clearSearch = output<void>();
  public itemSelected = output<AttachmentSearchResult>();

  protected goToAttachment(attachmentSearchResult: AttachmentSearchResult) {
    this.itemSelected.emit(attachmentSearchResult);
  }
}
